/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import ContactForm from "../components/Contactus/ContactForm";
import { useLenis } from "../components/SmoothScroll";
import { Helmet } from "react-helmet-async";
export default function ContactUsPage() {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);

  return (
    <>
      <Helmet>
        <title>Contact CDC Florida | Imaging Appointments and Support.</title>
        <meta
          name="description"
          content="Get in touch with CDC Florida for scheduling appointments, general inquiries, or assistance related to imaging services, availability, and coordination.
"
        />
        <meta
          name="keywords"
          content="contact us
medical imaging center
Schedule Imaging appointment
diagnostic imaging center


"
        />
      </Helmet>

      <ContactForm />
    </>
  );
}
